module.exports = __webpack_public_path__ + "img/panelView_baoSteel_3_3.a39b8c14.png";